import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Circle, Fill, Stroke, Style } from "ol/style";

import { SEARCH_HIGHLIGHT_LAYER_NAME } from "./constants";

export default function createSearchHighlightLayer() {
  return new VectorLayer({
    // @ts-expect-error -  bad typing in ol custom prop are allowed
    name: SEARCH_HIGHLIGHT_LAYER_NAME,
    source: new VectorSource({ useSpatialIndex: false }),
    style: new Style({
      fill: new Fill({
        color: [235, 0, 0, 0.15],
      }),
      image: new Circle({
        fill: new Fill({ color: [235, 0, 0, 0.5] }),
        radius: 10,
        stroke: new Stroke({ color: [235, 0, 0], width: 2 }),
      }),
      stroke: new Stroke({
        color: [235, 0, 0],
        width: 3,
      }),
    }),
    updateWhileAnimating: true,
    updateWhileInteracting: true,
    zIndex: 1100,
  });
}
